import {
  createContext,
  FC,
  ReactNode,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

type UserType = {
  email?: "";
  firstName?: "";
  lastName?: "";
};

const userContext = createContext<UserType>({
  email: "",
  firstName: "",
  lastName: "",
});

export const UserProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const { Provider } = userContext;
  const navigate = useNavigate();

  const [data, setData] = useState<UserType>({});

  const clear = useCallback(() => {
    localStorage.clear();
    sessionStorage.clear();
    navigate("/");
  }, [navigate]);

  const onLoad = useCallback(async () => {
    const refreshToken = sessionStorage.getItem(
      process.env.REACT_APP_REFRESH_TOKEN as string,
    );
    const token = sessionStorage.getItem(process.env.REACT_APP_TOKEN as string);
    if (!refreshToken || !token) {
      clear();
      return;
    }

    const decoded = jwtDecode(token) as UserType;

    setData({
      email: decoded.email,
      firstName: decoded.firstName,
      lastName: decoded.lastName,
    });
  }, [clear]);

  useEffect(() => {
    onLoad();
  }, [onLoad]);
  return <Provider value={{ ...data }}>{children}</Provider>;
};

export const useUser = () => {
  const user = useContext(userContext);
  return user;
};
